const NAME = "TYPES_OF_PUBLICATION_CHANNELS";

export default NAME;
